import { List, ListProps, ListItemText } from '@mui/material'
import { Device, GeoCoordinate } from '../types'
import { useTranslation } from 'react-i18next'
import CopyableListItemButton from './CopyableListItemButton'

interface DeviceDetailsListProps extends Omit<ListProps, 'children'> {
  device: Device
}

export default function DeviceDetailsList({ device, ...props }: DeviceDetailsListProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The current location of the device.
   */
  const currentLocation: GeoCoordinate | null = device?.locationHistory?.[0]
    ? {
        lat: parseFloat(device.locationHistory[0].lat.toString()),
        long: parseFloat(device.locationHistory[0].lng.toString())
      }
    : null

  return (
    <List {...props}>
      {device?.asset?.name && device.asset.name !== device.name && (
        <CopyableListItemButton copyText={device.asset.name}>
          <ListItemText primary={device.asset.name} secondary={t('name')} />
        </CopyableListItemButton>
      )}

      <CopyableListItemButton key="device-code" copyText={device.name || ''}>
        <ListItemText primary={device.name} secondary={t('deviceCode')} />
      </CopyableListItemButton>

      <CopyableListItemButton key="short-uuid" copyText={device.shortUUID || ''}>
        <ListItemText primary={device.shortUUID} secondary={t('shortUUID')} />
      </CopyableListItemButton>

      {currentLocation && (
        <CopyableListItemButton
          key="current-location"
          copyText={`${currentLocation.lat}, ${currentLocation.long}`}
        >
          <ListItemText
            primary={`${currentLocation.lat}, ${currentLocation.long}`}
            secondary={t('currentLocation')}
          />
        </CopyableListItemButton>
      )}

      {device?.asset?.project && (
        <CopyableListItemButton key="project" copyText={device.asset.project.name || ''}>
          <ListItemText primary={device.asset.project.name} secondary={t('project')} />
        </CopyableListItemButton>
      )}

      {device?.asset?.company && (
        <CopyableListItemButton key="company" copyText={device.asset.company.name || ''}>
          <ListItemText primary={device.asset.company.name} secondary={t('owner')} />
        </CopyableListItemButton>
      )}
    </List>
  )
}
